<h2 mat-dialog-title>{{ 'COMMON.SETTINGS' | translate }}</h2>
<mat-dialog-content>
  <mat-list>
    <glxy-form-field>
      <glxy-label>{{ 'LOCAL_SEO.SELECT_LOCAL_SEARCH_RADIUS.MAP_UNITS.LABEL' | translate }}</glxy-label>
      <mat-radio-group [value]="selectedMapUnit" (change)="setMapUnit($event.value)">
        <mat-radio-button value="{{ 'LOCAL_SEO.SELECT_LOCAL_SEARCH_RADIUS.MILES' | translate }}">
          {{ 'LOCAL_SEO.SELECT_LOCAL_SEARCH_RADIUS.MAP_UNITS.MILES' | translate }}
        </mat-radio-button>
        <mat-radio-button value="{{ 'LOCAL_SEO.SELECT_LOCAL_SEARCH_RADIUS.KMS' | translate }}">
          {{ 'LOCAL_SEO.SELECT_LOCAL_SEARCH_RADIUS.MAP_UNITS.KILOMETERS' | translate }}
        </mat-radio-button>
      </mat-radio-group>
    </glxy-form-field>
    <glxy-form-field>
      <glxy-label>{{ 'LOCAL_SEO.SELECT_LOCAL_SEARCH_RADIUS.LABEL' | translate }}</glxy-label>
      <mat-select [(value)]="selectedValue">
        <mat-option *ngFor="let option of options" [value]="option.value">
          {{ option.label | translate: { mapUnits: selectedMapUnit } | mileToKilometer: translatedMapUnitsKMS }}
        </mat-option>
      </mat-select>
    </glxy-form-field>

    <glxy-label-hint class="radius-description">
      {{ 'LOCAL_SEO.SELECT_LOCAL_SEARCH_RADIUS.DESCRIPTION' | translate }}
    </glxy-label-hint>

    <glxy-form-field class="full-search-field">
      <glxy-label>{{ 'LOCAL_SEO.KEYWORD.FULL_URL.LABEL' | translate }}</glxy-label>
      <glxy-checkbox [(ngModel)]="isFullSearchEnabled">
        {{ 'LOCAL_SEO.KEYWORD.FULL_URL.CHECK_BOX.CONTENT' | translate }}
      </glxy-checkbox>
    </glxy-form-field>
    <glxy-label-hint class="radius-description" class="full-search-hint">
      {{ 'LOCAL_SEO.KEYWORD.FULL_URL.CHECK_BOX.DESCRIPTION' | translate }}
    </glxy-label-hint>
  </mat-list>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="closeModal(false)">{{ 'COMMON.CANCEL' | translate }}</button>
  <button mat-flat-button color="primary" (click)="closeModal(true)">{{ 'COMMON.APPLY' | translate }}</button>
</mat-dialog-actions>
